import yup from '@/init/yup';
import { yupResolver } from '@hookform/resolvers/yup';

export enum Field {
  mail = 'mail',
  phone = 'phone',
  ibowid = 'ibowid',
}

export const RequestPasswordResetSchema = yup.object().shape({
  field: yup
    .mixed<Field>()
    .oneOf(Object.values(Field))
    .required('選択してください'),
  mail: yup.string().when('field', {
    is: Field.mail,
    then: (schema) =>
      schema
        .required('入力してください')
        .email('emailの形式が正しくありません'),
  }),
  phone: yup.string().when('field', {
    is: Field.phone,
    then: (schema) =>
      schema
        .required('入力してください')
        .matches(/^\d{10,11}$/, '電話番号の形式が正しくありません'),
  }),
  ibowid: yup.string().when('field', {
    is: Field.ibowid,
    then: (schema) => schema.required('入力してください'),
  }),
});
export type RequestPasswordResetType = yup.InferType<
  typeof RequestPasswordResetSchema
>;
export const RequestPasswordResetResolver = yupResolver(
  RequestPasswordResetSchema,
);
